import React from "react";
import { Outlet } from "react-router-dom";
import MFooterNavigation from "../ui/atoms/MFooterNavigation";

/**
 * HomeLayout: Used for home/dashboard/root screens.
 * Renders header (if any) and persistent footer navigation.
 */
const HomeLayout: React.FC = () => {
  return (
    <div
      className="flex flex-col bg-white curvy-gradient-onboarding"
      style={{
        height: "calc(var(--vh, 1vh) * 100)",
        overflow: "hidden",
      }}
    >
      <main
        className="flex-1 min-h-0 overflow-auto overflow-x-hidden bg-white"
        style={{
          paddingBottom: "calc(85px + env(safe-area-inset-bottom))",
        }}
      >
        <Outlet />
      </main>
      <MFooterNavigation />
    </div>
  );
};

export default HomeLayout;
